import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { ItineraryItem } from '../types';
import ItineraryItemCard from './ItineraryItemCard';

interface SortableItineraryItemProps {
  item: ItineraryItem;
  isSelected?: boolean;
  onClick?: () => void;
  onEdit?: (item: ItineraryItem) => void;
  onDelete?: (item: ItineraryItem) => void;
  onMarkDone?: (item: ItineraryItem) => void;
}

const SortableItineraryItem: React.FC<SortableItineraryItemProps> = ({ item, isSelected, onClick, onEdit, onDelete, onMarkDone }) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ 
    id: item.itemId, 
    data: { type: 'item', item },
    // Only allow dragging from the handle (reorder button), not the whole card
    disabled: false
  });

  // Slow down sibling displacement to improve readability while reordering
  const customTransition = isDragging
    ? 'transform 160ms ease-out' // keep the dragged item responsive
    : 'transform 420ms cubic-bezier(0.22, 1, 0.36, 1)'; // slower, springy displacement for others

  const style: React.CSSProperties = {
    transform: CSS.Transform.toString(transform),
    transition: customTransition || transition,
    touchAction: isDragging ? 'none' : 'pan-y', // Prevent scrolling during drag
    willChange: 'transform',
    zIndex: isDragging ? 50 : 'auto',
    userSelect: 'none',
    WebkitUserSelect: 'none',
  };

  return (
    <div ref={setNodeRef} style={style}>
      <ItineraryItemCard
        item={item}
        isSelected={isSelected}
        onClick={onClick}
        onEdit={onEdit}
        onDelete={onDelete}
        onMarkDone={onMarkDone}
        dragHandleProps={{ attributes, listeners }}
        isDragging={isDragging}
      />
    </div>
  );
};

export default SortableItineraryItem;


